export const LIST_ME_CLIENTS = 'LIST_ME_CLIENTS';
export const CHANGE_CLIENT = 'CHANGE_CLIENT';
export const SET_CLIENT = 'SET_CLIENT';
export const GET_CLIENT = 'GET_CLIENT';
export const LIST_AGENTS = 'LIST_AGENTS';
